export default function getLocale(fullLocale=false){
    if(document.documentElement.getAttribute("lang")==="en"||
        document.documentElement.getAttribute("lang")==="fr"){
        return document.documentElement.getAttribute("lang");
    }
    else {
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookies = decodedCookie.split(";");
        const name = ".AspNetCore.Culture";
        let locale: string;
        locale = "en";
        for (let c of cookies) {
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                locale = c.substring(22, 24);
            }
        }
        document.documentElement.setAttribute("lang",locale);
        if(fullLocale===true){
            if(locale==="en"){locale="en-CA"}
            else if (locale==="fr"){locale="fr-CA"}
        }
        return locale;
    }
}